import type { DtActionsAtom } from '@/components/pages/backoffice/_klb-penyuluh/_kecamatan/state/atoms'
import type {
  ServiceGetAllResponse,
  ServiceGetByIdResponse,
  ServiceMutationOptionType,
  ServiceQueryOptionType
} from '@/types/service'

import { api, handleAxiosError } from '@/lib/axios'

import type { KlasifikasiDataType } from './types'
import type { MutationKlasifikasiValues } from './validations'

const QUERY_KEY = (key?: string | Record<string, any>) =>
  ['klasifikasi', key] as const

const getAll = (
  params?: DtActionsAtom
): ServiceQueryOptionType<
  ServiceGetAllResponse<Array<KlasifikasiDataType>>
> => ({
  queryKey: QUERY_KEY(params),
  queryFn: async () => {
    try {
      const response = await api.get<
        ServiceGetAllResponse<Array<KlasifikasiDataType>>
      >(`kelembagaan/bpp/${params?.id_bpp}/klasifikasi`, {
        params: {
          page: params?.page,
          per_page: params?.perPage || undefined
        }
      })

      return response.data
    } catch (error) {
      throw handleAxiosError(error)
    }
  }
})

const getById = (
  id: string,
  id_bpp?: string
): ServiceQueryOptionType<ServiceGetByIdResponse<KlasifikasiDataType>> => ({
  queryKey: QUERY_KEY(id),
  queryFn: async () => {
    try {
      const response = await api.get<
        ServiceGetByIdResponse<KlasifikasiDataType>
      >(`kelembagaan/bpp/${id_bpp ?? ''}/klasifikasi/${id}`)
      return response.data
    } catch (error) {
      throw handleAxiosError(error)
    }
  }
})

const create = (): ServiceMutationOptionType<
  ServiceGetByIdResponse<KlasifikasiDataType>,
  MutationKlasifikasiValues
> => ({
  mutationKey: QUERY_KEY(undefined),
  mutationFn: async (data: MutationKlasifikasiValues) => {
    try {
      const response = await api.post(
        `kelembagaan/bpp/${data.id_bpp ?? ''}/klasifikasi`,
        {
          ...data,
          id_klasifikasi_bpp: data.id_klasifikasi_bpp?.value
        }
      )

      return response.data
    } catch (error) {
      throw handleAxiosError(error)
    }
  }
})

const update = (): ServiceMutationOptionType<
  ServiceGetByIdResponse<KlasifikasiDataType>,
  MutationKlasifikasiValues
> => ({
  mutationKey: QUERY_KEY(undefined),
  mutationFn: async (data: MutationKlasifikasiValues) => {
    try {
      const response = await api.put<
        ServiceGetByIdResponse<KlasifikasiDataType>
      >(
        `kelembagaan/bpp/${data?.id_bpp ?? ''}/klasifikasi/${data.id_klasifikasi}`,
        {
          ...data,
          id_klasifikasi_bpp: data.id_klasifikasi_bpp?.value
        }
      )
      return response.data
    } catch (error) {
      throw handleAxiosError(error)
    }
  }
})

const deleteData = (): ServiceMutationOptionType<
  ServiceGetByIdResponse<KlasifikasiDataType>,
  { id: string; id_bpp: string }
> => ({
  mutationFn: async (data: { id: string; id_bpp: string }) => {
    try {
      const response = await api.delete<
        ServiceGetByIdResponse<KlasifikasiDataType>
      >(`kelembagaan/bpp/${data?.id_bpp ?? ''}/klasifikasi/${data.id}`)
      return response.data
    } catch (error) {
      throw handleAxiosError(error)
    }
  }
})

export const klasifikasi = {
  queryKey: [QUERY_KEY(undefined)[0]],
  getAll,
  getById,
  create,
  update,
  deleteData
}
